import { PayloadAction } from '@reduxjs/toolkit';

import { TourState } from 'editor/src/store/editorModules/tour/types';

const setActiveIntroStepReducer = (state: TourState, action: PayloadAction<number | undefined>) => {
  state.activeIntroTourStep = action.payload;
};

export default setActiveIntroStepReducer;
